import React from 'react';
import Menu from './componentes/menu';
import { Outlet,Route, Routes, BrowserRouter} from "react-router-dom";
import './App.css';
import { Toaster } from 'react-hot-toast';
import { GlobalNavigationProvider } from './contexts/GlobalNavigationContext';


import DashBoard from './componentes/dashboard';
import Paciente from './componentes/paciente/paciente';
import CadPaciente from './componentes/paciente/cadpaciente';
import EditarPaciente from './componentes/paciente/editarpaciente';
import Teste from './componentes/teste';
import Medico from './componentes/medico/medico';
import EditarMedico from './componentes/medico/editarmedico';
import CadMedico from './componentes/medico/cadmedico';
import Medicamento from './componentes/medicamento/medicamento';
import EditarMedicamento from './componentes/medicamento/editarmedicamento';
import CadMedicamento from './componentes/medicamento/cadmedicamento';
import Texto from './componentes/texto/texto';
import EditarTexto from './componentes/texto/editartexto';
import CadTexto from './componentes/texto/cadtexto';
import Agenda from './componentes/agenda/agenda';
import Agendamento from './componentes/agenda/agendamento';
import AgendaEditar from './componentes/agenda/agendaeditar';
import FichaPaciente from './componentes/fichapaciente/fichapaciente';
import FichaPacienteAcesso from './componentes/fichapaciente/fichapacienteacesso';
import RelReceituario from './componentes/fichapaciente/relreceituario';
import ImpAgenda from './componentes/relatorios/impagenda';
import ConfAgenda from './componentes/agenda/confagenda';
import WhatsApp from './componentes/whatsApp/whatsapp';
import LandingPage from './componentes/LandingPage';
import Login from '../src/login';
import Clinica from './componentes/clinica/clinica';


function App() {  

  const AppLayout = () => {
    return(
   <>  <Toaster position="top-right" reverseOrder={false}/>
       <Menu />   {/* // MEU MENU */}      
       <div className='conteudoOutlet'>
          <Outlet />  {/* // INDICA QUE AS PÁGINAS OU ROTAS VAO ABRIR ABAIXO DO MENU */}
      </div>
    </>
    )
  }
                                        //OS PARAMETROS DAS URLS SÃO PASSADOS NO PATH E PEGADOS NO DESTINO COM  useParams
  const Rotas = () =>(
    <GlobalNavigationProvider>
      <BrowserRouter>                                   {/* // PARA INDICAR QUE É ROTA */}    
        <Routes>                                        {/* // PARA INDICAR QUE É ROTA */}        
          <Route element={<AppLayout />}>               {/* // AQUI ELE CHAMA O APPLAYOUT ACIMA  */}        
            <Route path="/" element= {<DashBoard />}/>
            <Route path= "/login" element= {<Login />}/>
            <Route path= "/landingpage" element= {<LandingPage />}/>

            <Route path="/paciente/paciente" element= {<Paciente />}/>
            <Route path="/paciente/cadpaciente" element= {<CadPaciente />}/>
            <Route path="/paciente/editarpaciente/:id/:whereFrom" element= {<EditarPaciente />}/>

            <Route path="/clinica/clinica" element= {<Clinica />}/>

            <Route path="/teste" element= {<Teste />}/>

            <Route path="/medico/medico" element= {<Medico />}/>
            <Route path="/medico/editarmedico/:id" element= {<EditarMedico  />}/>
            <Route path="/medico/cadmedico" element= {<CadMedico />}/>

            <Route path="/agenda/agenda" element= {<Agenda />}/>
            <Route path="/agenda/agendamento/:idMed/:date/:horaProps/:encaixe" element= {<Agendamento />}/>
            <Route path="/agenda/agendaeditar/:id/:idPac/:encaixe" element= {<AgendaEditar   />}/>

            <Route path="/fichapaciente/fichapaciente/:idMed/:idPac" element= {<FichaPaciente  />}/>
            <Route path="/fichapaciente/fichapacienteacesso" element= {<FichaPacienteAcesso />}/>
            <Route path="/fichapaciente/relreceituario" element= {<RelReceituario />}/>

            <Route path="/medicamento/medicamento" element= {<Medicamento />}/>
            <Route path="/medicamento/editarmedicamento/:id" element= {<EditarMedicamento  />}/>
            <Route path="/medicamento/cadmedicamento" element= {<CadMedicamento />}/>

            <Route path="/texto/texto" element= {<Texto />}/>
            <Route path="/texto/editartexto/:id" element= {<EditarTexto  />}/>
            <Route path="/texto/cadtexto" element= {<CadTexto />}/>

            <Route path="/relatorios/impagenda" element= {<ImpAgenda />}/>
            <Route path="/agenda/confagenda" element= {<ConfAgenda />}/>
            <Route path="/whatsApp/whatsapp" element= {<WhatsApp />}/>

          </Route>
        </Routes>
      </BrowserRouter> 
    </GlobalNavigationProvider>
    )


    return (
      <>
         
        <Rotas />  {/* CHAMA AS ROTAS ACIMA */}
        

      </>
      )
  }   

export default App; 
